import 'bootstrap/dist/css/bootstrap.css';
import branch from 'branch-sdk';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';
import App from './App';
import './index.css';
import {ConsoleLogger, DatadogLogger, initDatadog, isDatadogEnabled, LoggerManager} from './logger';
import reportWebVitals from './reportWebVitals';

createRoot(document.getElementById('root') as Element).render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
);

branch.init(process.env.REACT_APP_BRANCH_KEY as '');
// If you want to start measuring performance in your app, pass a function
// to send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (isDatadogEnabled()) {
  initDatadog();
  LoggerManager.addLogger(DatadogLogger);
} else {
  LoggerManager.addLogger(ConsoleLogger);
}
reportWebVitals(console.log);
